<h1>{{data.mensaje}}</h1>
<div style="width: 100%; text-align: center">
    <mat-card-actions>
      <button mat-raised-button (click)="onNoClick()" color="primary">Aceptar</button>
    </mat-card-actions>
</div>